// Module
var code = "<template> <ess-select value.bind=\"value\" options.bind=\"choices\" placeholder=\"${definition.description}\" label=\"${definition.description}\" disabled.bind=\"disabled\"></ess-select> </template> ";
// Exports
module.exports = code;